import { articlePreviews } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function ArticlesSection() {
  // Show first 9 in grid, remaining in a second row on desktop
  const gridArticles = articlePreviews.slice(0, 9);
  const remainingArticles = articlePreviews.slice(9);

  return (
    <section className="py-16 md:py-24 bg-foreground-950">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 md:mb-14 gap-6">
          <div>
            <p className="font-label text-xs md:text-sm uppercase tracking-[0.2em] text-accent-400 mb-3">
              Latest Updates
            </p>
            <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-[1.15]">
              Latest Spreadsheet
              <br />
              Guides
            </h2>
          </div>
          <Link
            to="/article/ultimate-superbuy-spreadsheet-guide-2026"
            className="flex items-center gap-2 text-background-50/70 font-label text-sm hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
          >
            <span>View All Guides</span>
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        {/* Articles Grid - 3 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {gridArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:translate-y-[-4px] transition-all duration-300 cursor-pointer"
            >
              {/* Article Image */}
              <div className="relative w-full h-44 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 bg-background-50/90 text-foreground-800 font-label text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Article Info */}
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="font-body text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <p className="font-label text-xs text-foreground-400">{article.date}</p>
              </div>
            </Link>
          ))}
        </div>

        {/* Remaining articles row */}
        {remainingArticles.length > 0 && (
          <div className="mt-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {remainingArticles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50/10 rounded-xl overflow-hidden hover:bg-background-50/15 hover:translate-y-[-2px] transition-all duration-300 cursor-pointer border border-background-50/8"
                >
                  <div className="relative w-full h-36 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2 left-2">
                      <span className="px-2 py-0.5 bg-foreground-950/70 text-background-50/90 font-label text-xs rounded-full">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-sm font-semibold text-background-50/90 mb-1 line-clamp-2 group-hover:text-background-50 transition-colors duration-200">
                      {article.title}
                    </h3>
                    <p className="font-label text-xs text-background-50/40">{article.date}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* CTA link at bottom */}
        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <span>Browse All Categories</span>
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}